<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>学校管理</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <div class="search-line clearfix">
          <!-- 学校管理条件查找 -->
          <select
            class="s-select separate"
            v-model="querySchoolInfo.status"
          >
            <option value="">学校状态</option>
            <option value="0">禁用</option>
            <option value="1">启用</option>
          </select>
          <select
            class="s-select separate"
            v-model="querySchoolInfo.province"
          >
            <option value="">所属省份</option>
            <option
              :value="key"
              v-for="(val, key) in provinceData"
              :key="key"
            >{{ val }}</option>
          </select>
          <select
            class="s-select separate"
            v-model="querySchoolInfo.level"
          >
            <option value="">教育层次</option>
            <option
              :value="key"
              v-for="(val, key) in schoolLevel"
              :key="key"
            >{{ val }}</option>
          </select>
          <input
            type="text"
            placeholder="学校名称"
            class="s-input separate"
            v-model="querySchoolInfo.title"
          >
          <input
            type="button"
            value="搜索"
            class="s-btn"
            @click="pageSchoolCallback(1)"
          >
          <div
            class="add-btn"
            style="margin-bottom:0;"
            @click="showAddWindow(onClick,'add')"
          >新建</div>
          <!-- <div
            class="import-btn"
            id="batchUpload"
            @click="showUploadWindow"
          >导入</div> -->
        </div>
      </div>
      <!-- 学校列表 -->
      <div id="list">
        <table v-if="schoolTableData.length">
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">学校编号</th>
              <th class="itemStatus">学校名称</th>
              <th class="itemStatus">教育层次</th>
              <th class="itemStatus">学院数量</th>
              <th class="itemStatus">所属省份</th>
              <th class="itemStatus">状态</th>
              <th
                class="action"
                width="180"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in schoolTableData"
              :key="item.id"
            >
              <td class="itemStatus">{{item.code?item.code:'--'}}</td>
              <td class="itemStatus">{{item.title}}</td>
              <td class="itemStatus">{{formatLevel(item.level)}}</td>
              <td class="itemStatus">{{item.academy_count}}</td>
              <td class="itemStatus">{{formatProvince(item.province)}}</td>
              <td :class="'itemStatus itemStatus' + item.status">{{ item.status == 1 ? '已启用' : '禁用' }}</td>
              <td class="action">
                <a
                  class="edit"
                  href="javascript:;"
                  @click="querySchoolSingle(item.id)"
                >编辑</a>
                <a
                  v-if="item.status==1"
                  class="nopublish"
                  href="javascript:;"
                  @click="unpublish(item,onClick)"
                >禁用</a>
                <a
                  v-if="item.status==0"
                  class="publish"
                  href="javascript:;"
                  @click="publish(item,onClick)"
                >启用</a>
                <a
                  class="delete"
                  href="javascript:;"
                  @click="askNoDelete"
                  v-if="item.academy_count>0"
                >删除</a>
                <a
                  class="delete"
                  href="javascript:;"
                  @click="askDelete(item)"
                  v-else
                >删除</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
        <!-- 分页 -->
        <pagination
          :cur='pageSchoolInfo.page'
          :all='pageSchoolInfo.all'
          :totalData="pageSchoolInfo.totalData"
          :callback="pageSchoolCallback"
        ></pagination>
      </div>

      <!-- 专业添加/编辑弹窗 -->
      <div
        class="form_overlay"
        :style="classShowAddWindow"
      >
        <div class="form_overlay_bg"></div>
        <!-- 学校管理 -->
        <div class="form_panel">
          <div class="form_title">学校管理</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"><i class="require">*</i>学校编号:</span>
                <input
                  type="hidden"
                  v-model="schoolInfo.id"
                >
                <input
                  type="text"
                  v-model="schoolInfo.code"
                  maxlength="25"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>学校名称:</span>
                <input
                  type="text"
                  v-model="schoolInfo.title"
                  maxlength="12"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>所属省份:</span>
                <select v-model="schoolInfo.province">
                  <option value="">选择省份</option>
                  <option
                    :value="key"
                    v-for="(val, key) in provinceData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>教育层次:</span>
                <select v-model="schoolInfo.level">
                  <option value="">选择教育层次</option>
                  <option
                    :value="key"
                    v-for="(val, key) in schoolLevel"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="saveSchoolInfo"
            >提交</a>
          </div>
        </div>
      </div>
      <div
        class="form_overlay"
        :style="classShowUploadWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">批量上传</div>
          <div class="form_content">
            <form id="uploadForm">
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                ><i class="require"></i>模版创建规则:</span>
                <div class="item-box divLabel gray">
                  <div class="normal-width">
                    <p>1. 文件格式为常用的Excel文件（*.xlsx或*.xls）；</p>
                    <p>2. 填写导入数据时，需先删除导入模版中首行以下所有说明示例数据，且第二行中文说明字段前带*号的为必填项；</p>
                    <p>3. 导入文件中如存在多个sheet工作表，表头应与示例工作表表头完全一致；</p>
                    <p>4. 导入的数据总条数不得超过2000条，如超过，则需分多次导入；</p>
                    <p>5. 注意：请保证“专业”所属“父级编号”的学院信息位置在前。</p>
                  </div>
                </div>
                <div class="clear"></div>
                <div class="attachment">
                  <a
                    href="/static/upload_template/batch_upload_academy_template.csv"
                    download="batch_upload_user_template.csv"
                    target="_blank"
                  >模版下载</a>
                </div>
              </div>
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                ><i class="require">*</i>CSV文件:</span>
                <div
                  class="item-box"
                  style="margin-left: 130px;"
                >
                  <input
                    v-model="uploadedCsv"
                    disabled
                    type="text"
                    id="fileUrl"
                    style="width: 225px;"
                  >
                  <span
                    class="button"
                    style="position: relative;top: 0px; left: 0px;"
                  >
                    选择文件
                    <input
                      @change="xlsChange"
                      type="file"
                      accept=".csv,.xls,.xlsx"
                      ref="xlsFile"
                      id="fileUpload"
                      class="upload-derict"
                    >
                  </span>
                </div>
                <div class="clear"></div>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              style="width: 30px"
              class="button close"
              id="form_upload_close"
              @click="hideUploadWindow"
            >取消</a>
            <a
              href="javascript:;"
              style="width: 30px"
              class="button"
              id="form_upload_submit"
              @click="submitCsv"
            >提交</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Academy',
  components: {
    Pagination
  },
  data() {
    return {
      onClick: 1,
      classShowAddWindow: {},
      classShowUploadWindow: {},
      schoolTableData: [],
      schoolTableDataCount: 0, // 学校列表总数据

      querySchoolInfo: {
        page: 1,
        size: 10,
        status: '',
        province: '',
        title: '',
        level: ''
      },

      uploadedCsv: '',
      schoolInfo: { // 学校表单数据
        id: 0,
        title: '',
        code: '',
        status: '1',
        province: '',
        level: ''
      }

    }
  },
  methods: {
    formatProvince(value) {
      return value ? this.$store.state.dict_province[value] : '--'
    },
    formatLevel(value) {
      return value ? this.$store.state.dict_school_level[value] : '--'
    },
    async xlsChange() {
      const uploadUrl = '/files/' + this.$refs.xlsFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.xlsFile.files[0]).then((data) => {
        this.uploadedCsv = data
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },

    // 打开专业添加/编辑弹窗
    showAddWindow() {
      this.schoolInfo = { // 学校表单数据
        id: 0,
        title: '',
        code: '',
        status: '1',
        level: '',
        province: ''
      }
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 关闭专业添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
    },
    // 打开上传弹窗
    showUploadWindow() {
      this.classShowUploadWindow = {
        visibility: 'visible'
      }
    },
    // 关闭上传弹窗
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    // 禁用
    unpublish(item) {
      this.$parent.showConfirm('确定要禁用该记录吗？', () => {
        this.askDisable(item, 0)
      })
    },
    // 启用
    publish(item) {
      this.$parent.showConfirm('确定要启用该记录吗？', () => {
        this.askDisable(item, 1)
      })
    },
    // 禁用
    async askDisable(item, status) {
      const msg = status === 0 ? '禁用' : '启用'
      var params
      params = {
        code: item.code,
        title: item.title,
        status: status
      }

      const url = '/school/' + item.id + '/'
      await this.$http.put(url, params).then((data) => {
        this.$parent.showMsg(msg + '成功！')
        this.searchSchool()
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg(msg + '失败！')
      })
    },
    // 获取学校数据
    async searchSchool() {
      await this.$http.get('/school/', {
        params: this.querySchoolInfo
      }).then((data) => {
        this.schoolTableData = data.results
        this.schoolTableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },

    // 新增/编辑学校
    async saveSchoolInfo() {
      if (!this.schoolInfo.code) {
        this.$layer.msg('请输入学校编号!')
        return false
      }
      if (!this.schoolInfo.title) {
        this.$layer.msg('请输入学校名称!')
        return false
      }
      if (!this.schoolInfo.province) {
        this.$layer.msg('请选择省份!')
        return false
      }
      if (!this.schoolInfo.level) {
        this.$layer.msg('请选择教育层次!')
        return false
      }
      const checkCodeData = await this.$http.get('/school/', {
        params: {
          eq_code: this.schoolInfo.code
        }
      })
      const checkTitleData = await this.$http.get('/school/', {
        params: {
          eq_title: this.schoolInfo.title
        }
      })

      if (this.schoolInfo.id) {
        if (checkCodeData.results.length > 0) {
          for (let i = 0; i < checkCodeData.results.length; i++) {
            if (checkCodeData.results[i].id !== this.schoolInfo.id) {
              this.$layer.msg('学校编号已存在!')
              return false
            }
          }
        }
        if (checkTitleData.results.length > 0) {
          for (let i = 0; i < checkTitleData.results.length; i++) {
            if (checkTitleData.results[i].id !== this.schoolInfo.id) {
              this.$layer.msg('学校名称已存在!')
              return false
            }
          }
        }
        const url = '/school/' + this.schoolInfo.id + '/'
        await this.$http.put(url, this.schoolInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.searchSchool()
          } else {
            this.$layer.msg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })
      } else {
        if (checkCodeData.results.length > 0) {
          this.$layer.msg('学校编号已存在!')
          return false
        }
        if (checkTitleData.results.length > 0) {
          this.$layer.msg('学校名称已存在!')
          return false
        }
        await this.$http.post('/school/', this.schoolInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.searchSchool()
          } else {
            this.$layer.msg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('添加失败！')
        })
      }
    },

    // 编辑时查询学校数据
    async querySchoolSingle(id) {
      const url = '/school/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.schoolInfo = {
          id: id,
          code: data.code,
          title: data.title,
          level: data.level ? data.level : '',
          province: data.province
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },

    askNoDelete() {
      this.$parent.showMsg('该学校下面有学院,暂时无法删除！')
    },
    // 删除学校
    async askDelete(item) {
      const url = '/school/' + item.id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          code: item.code,
          title: item.title,
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.searchSchool()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    async submitCsv() {
      const uploadUrl = '/get_csv/'
      await this.$http.get(uploadUrl, {
        params: {
          file_name: this.uploadedCsv
        }
      }).then((data) => {
        if (data.length <= 2) {
          this.$parent.showMsg('表格中无数据！')
          return
        }

        data.splice(0, 2)

        this.uploadedCscData = data

        this.hideUploadWindow()

        this.classShowProcessWindow = {
          visibility: 'visible'
        }
        this.isFinishUpsert = false
        this.curCsvIndex = 0
        this.csvFinishText = ''
        this.errorList = []
        this.insertOne()
      }).catch(() => {
        this.$parent.showMsg('读取失败！')
      })
    },
    async insertOne() {
      if (this.curCsvIndex >= this.uploadedCscData.length) {
        this.csvFinishText = '上传完成'
        this.isFinishUpsert = true
        this.searchSchool()
        return
      }

      const row = this.uploadedCscData[this.curCsvIndex]
      // region 数据检查开始

      if (row[0].trim().length === 0) {
        this.$parent.showMsg('请输入编号！')
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[1].trim().length === 0) {
        this.$parent.showMsg('请输入名称！')
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      if (row[2].trim().length === 0) {
        this.$parent.showMsg('请输入所属省份！')
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      var obj = this.$store.state.dict_province
      var provinceKey = ''
      Object.keys(obj).forEach(function(key) {
        if (obj[key] === row[2]) {
          provinceKey = key
        } else {
          provinceKey = '0'
        }
      })
      if (provinceKey === '0') {
        this.$parent.showMsg('省份错误，请参照模板给出的省份进行添加！')
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      var addForm = {
        code: row[0],
        title: row[1],
        status: 1,
        province: provinceKey
      }

      await this.$http.post('/school/', addForm).then(async (data) => {
        this.errorList.push({ code: 1, text: '[' + addForm.title + ']' + '导入成功！' })
        this.curCsvIndex++
        this.insertOne()
      }).catch((error) => {
        console.dir(error)
        this.errorList.push({ code: 0, text: '[' + addForm.title + ']' + error.response.data[0] })
        this.curCsvIndex++
        this.insertOne()
      })
    },
    // 学校分页
    pageSchoolCallback(data) {
      this.querySchoolInfo.page = data
      this.searchSchool()
    }

  },
  // 计算属性
  computed: {
    // 学校分页查询
    pageSchoolInfo() {
      return {
        page: this.querySchoolInfo.page,
        all: Math.ceil(this.schoolTableDataCount / this.querySchoolInfo.size),
        totalData: this.schoolTableDataCount
      }
    },

    localUser() {
      return this.$store.state.userInfo
    },
    provinceData() {
      return this.$store.state.dict_province
    },
    schoolLevel() {
      return this.$store.state.dict_school_level
    }
  },
  mounted() {
    this.searchSchool()
  }
}
</script>

<style scoped>
</style>
